<template>
    <div class="tangeche tangehce-template-amy-or-souche">
        <div class="moduleTitle">最新车辆<a href="/buy.htm" class="more" target="_blank">更多&gt;&gt;</a></div>
        <div class="carsContent">
            <div class="hotNewCars">
                <div class="car-item-container" v-for="item in carListComputed">
                    <a :href="'/car/' + item.id">
                        <div class="car-item"
                            is="CarItem"
                            :data="item"
                            :class="[ 'line-height-level-' + lineHeightLevel ]">
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CarItem from '@souche-f2e/wangzhan-dependencies-car-item/vue/Large.vue';
    import {
        getLineHeightLevel
    } from 'babel!@souche-f2e/wangzhan-dependencies-car-item/src/car-util.js';
    
    export default {
        props: ['carList'],
        computed: {
            carListComputed() {
                return this.carList;
            },
            lineHeightLevel() {
                let retNum = 0;
                let tangeche = false;
                let loan = false;
                for (var i = 0; i < this.carList.length; i++) {
                    let lineHeightLevel = getLineHeightLevel(this.carList[i]);
                    if (lineHeightLevel > retNum) {
                        retNum = lineHeightLevel;
                    }
                }
                return retNum;
            }
        },
        components: {
            CarItem
        }
    };
</script>

<style lang="less" scoped>
    .tangeche.tangehce-template-amy-or-souche {
        width: 1180px;
        margin: 0 auto;
        font-size: 20px;
        padding-top: 10px;
        .moduleTitle {
            margin-top: 15px;
            font-weight: 400;
            margin-left: 15px;
        }
        .moduleTitle a.more {
            font-size: 12px;
            float: right;
            line-height: 40px;
            text-decoration: none;
            color: #333;
        }
        .carsContent {
            margin-top: 0;
            width: 100%;
            position: relative;
            overflow: hidden;
        }
        .hotNewCars {
            position: relative;
            overflow: hidden;
            width: 110%;
            .car-item-container {
                margin: 0 20px 20px 0;
                float: left;
                & > a {
                    text-decoration: none;
                }
                .car-item {
                    // 无弹个车标且无售价 -22px -29px;
                    &.line-height-level-0 {
                        height: 372px - 22px - 29px;
                    }
                    // 无售价 -22px
                    &.line-height-level-1 {
                        height: 372px - 22px;
                    }
                    &.line-height-level-2 {
                        height: 372px;
                    }
                }
            }
            &:after {
                content: '';
                display: block;
                clear: both;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// TemplateCrystalOrSouche.vue?8ab10162